import { AuthMethods } from '@/models/auth-methods';
import { CountryCodes } from '@/models/countries';
import { createI18n } from 'vue-i18n';
import es from './locales/es.json';
import fr from './locales/fr.json';

// JSON language files
const messages = {
  es,
  fr
};

const getLocaleFromEnvironment = () => {
  const locale = process.env.VUE_APP_AUTH_METHOD || AuthMethods.Spain;

  switch (locale) {
    case AuthMethods.Spain:
      return CountryCodes.SPAIN.toLowerCase();
    case AuthMethods.FranceMock:
      return CountryCodes.FRANCE.toLowerCase();
  }
};

const i18n = createI18n({
  legacy: false,
  locale: getLocaleFromEnvironment(),
  fallbackLocale: getLocaleFromEnvironment(),
  globalInjection: true,
  messages
});

export default i18n;
